export const $config = {
	url: 'https://sportog.ru/'
}
